<template>
  <div>
    <base-table
      ref="refTable"
      table-label="Users"
      namespace="user"
      name="users"
    >
      <template #before-navbar>
        <b-button variant="outline-primary" @click="showCreateModal">
          <feather-icon icon="PlusIcon"/> Create
        </b-button>
      </template>

      <template #item.id="{item}">
        <b-link :to="{name: 'user', params: {id: item.id}}" class="font-weight-bold">
          #{{ item.id }}
        </b-link>
      </template>

      <template #item.actions="{item}">
        <b-dropdown variant="link" no-caret :popper-opts="{ positionFixed: true }">
          <template #button-content>
            <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body"/>
          </template>

          <b-dropdown-item @click="showEditModal(item)">
            <feather-icon icon="EditIcon"/>
            <span class="align-middle ml-50">Edit</span>
          </b-dropdown-item>

          <b-dropdown-item @click="showChangePasswordModal(item)">
            <feather-icon icon="KeyIcon"/>
            <span class="align-middle ml-50">Change Password</span>
          </b-dropdown-item>

          <login-as-dropdown-item
            v-if="$can('users-login-as') && user.id !== item.id"
            :user-id="item.id"
          />
        </b-dropdown>
      </template>

    </base-table>

    <create-modal
      :visible.sync="createModal.visible"
      :user="createModal.user"
      @success="handleCreateSuccess"
    />

    <edit-modal
      :visible.sync="editModal.visible"
      :user="editModal.user"
      @success="handleEditSuccess"
    />

    <change-password-modal
      :visible.sync="changePasswordModal.visible"
      :user="changePasswordModal.user"
      @success="handleChangePasswordSuccess"
    />
  </div>
</template>
<script>
import {
  BTooltip,
  BDropdown,
  BDropdownItem,
  BBadge,
  BButton,
  BLink
} from 'bootstrap-vue'

import EditModal from "@models/user/modals/EditModal";
import CreateModal from "@models/user/modals/CreateModal";
import ChangePasswordModal from "@models/user/modals/ChangePasswordModal";
// import LoginAsDropdownItem from "@core/models/user/login-as/DropdownItem";

import {ref} from "@vue/composition-api";
import {mapGetters} from "vuex";

export default {
  name: 'UsersTable',
  components: {
    BTooltip,
    BDropdown,
    BDropdownItem,
    BBadge,
    BLink,
    BButton,

    CreateModal,
    EditModal,
    ChangePasswordModal,
    // LoginAsDropdownItem
  },
  computed: {
    ...mapGetters([
      'user',
    ])
  },
  setup(){
    const refTable = ref()

    //Create Modal
    const createModal = ref({visible: false, user: null})
    const showCreateModal = (user) => {
      createModal.value.user = JSON.parse(JSON.stringify({
        name: '',
        email: '',
        role: null,
        password: '',
        passwordRepeat: '',
      }))
      createModal.value.visible = true
    }
    const handleCreateSuccess = () => {
      createModal.value.visible = false;
      refTable.value.fetchData()
    }

    //Edit Modal
    const editModal = ref({visible: false, user: null})
    const showEditModal = (user) => {
      editModal.value.user = JSON.parse(JSON.stringify({
        id: user.id,
        name: user.name,
        email: user.email,
        active: user.active,
      }))
      editModal.value.visible = true
    }
    const handleEditSuccess = () => {
      editModal.value.visible = false;
      refTable.value.fetchData()
    }

    //Edit Modal
    const changePasswordModal = ref({visible: false, user: null})
    const showChangePasswordModal = (user) => {
      changePasswordModal.value.user = JSON.parse(JSON.stringify({
        id: user.id,
        password: '',
        passwordRepeat: '',
      }))
      changePasswordModal.value.visible = true
    }
    const handleChangePasswordSuccess = () => {
      changePasswordModal.value.visible = false;
      refTable.value.fetchData()
    }

    return {
      refTable,

      createModal,
      showCreateModal,
      handleCreateSuccess,

      editModal,
      showEditModal,
      handleEditSuccess,

      changePasswordModal,
      showChangePasswordModal,
      handleChangePasswordSuccess,
    }
  }
}
</script>
